export default __webpack_public_path__ + "static/media/llama_diorama.d5e82d32.png";